import { ComponentType } from 'react';
import { Cog8ToothIcon } from '@heroicons/react/24/outline';
import { QuestionMarkCircleIcon } from '@heroicons/react/24/outline';
import { EnvelopeIcon } from '@heroicons/react/24/outline';
import { LightBulbIcon } from '@heroicons/react/24/outline';

type MenuItemTitleKey = 'settings' | 'contact' | 'shareIdeas' | 'documentation';

export interface MenuItem {
  isExternal?: boolean;
  route: string;
  icon: ComponentType;
  title: MenuItemTitleKey;
}

export const reglageMenuItem: MenuItem = {
  route: '/direction/settings/account',
  icon: Cog8ToothIcon,
  title: 'settings',
};

export const contactUs: MenuItem = {
  route: '/direction/contact',
  icon: EnvelopeIcon,
  title: 'contact',
};

export const shareIdeas: MenuItem = {
  route: '/direction/contact',
  icon: LightBulbIcon,
  title: 'shareIdeas',
};

export const documentation: MenuItem = {
  isExternal: true,
  route: 'https://teetsh.com/documentation/',
  icon: QuestionMarkCircleIcon,
  title: 'documentation',
};
